import { useEffect, useState } from "react";
import BoardTable from "../../components/common/board/BoardTable";
import BoardPagination from "../../components/common/board/BoardPagination";
import SearchBar from "../../components/common/board/SearchFilterBar"; // 공통 필터 컴포넌트
import { getCompletionReportList } from "../../api/const";
import { useParams, useNavigate } from "react-router-dom";
import BoardToolbar from "../../components/common/board/BoardToolbar";
import PageHeader from "../../components/common/ui/PageHeader";

const OrderComplete = () => {
  const { id: projectId } = useParams();
  const navigate = useNavigate();

  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [total, setTotal] = useState(0);

  // 공통 SearchBar 기준 필터 구조로 변경
  const [q, setQ] = useState("");
  const [searchField, setSearchField] = useState("title");
  const [dateFilter, setDateFilter] = useState("all");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  // 검색 트리거
  const [searchTrigger, setSearchTrigger] = useState(0);

  const columns = [
    {
      key: "title",
      header: "제목",
      width: 300,
      render: (row) => <div className="truncate max-w-[250px]">{row.title}</div>,
    },
    {
      key: "date",
      header: "작성일",
      width: 160,
      render: (row) =>
        row.created_at ? new Date(row.created_at).toLocaleDateString("ko-KR") : "-",
    },
    {
      key: "is_approved",
      header: "승인 상태",
      width: 120,
      render: (row) => {
        const status = row.approval?.is_approved;
        const statusLabel = { submit: "승인대기", approved: "승인", rejected: "반려" }[status] || "-";
        const statusClass =
          {
            submit: "bg-yellow-100 text-yellow-800",
            approved: "bg-green-100 text-green-800",
            rejected: "bg-red-100 text-red-800",
          }[status] || "bg-gray-100 text-gray-800";

        return (
          <span className={`px-2 py-1 text-xs font-medium rounded-full border ${statusClass}`}>
            {statusLabel}
          </span>
        );
      },
    },
    {
      key: "created_by",
      header: "작성자",
      width: 120,
      render: (row) => <span>{row.created_by?.name || "-"}</span>,
    },
    {
      key: "confirmer",
      header: "승인자",
      width: 120,
      render: (row) => <span>{row.approval?.approver_name || "-"}</span>,
    },
  ];

  const fetchData = () => {
    if (!projectId) return;
    setLoading(true);
    setError("");

    const params = {
      project: projectId,
      [searchField]: q,
      start_date: startDate || undefined,
      end_date: endDate || undefined,
      page,
      page_size: pageSize,
    };

    getCompletionReportList(projectId, params)
      .then((res) => {
        setRows(res.results ?? res);
        setTotal(res.count ?? res.total ?? res.length);
      })
      .catch((err) => {
        console.error(err);
        setError("완료보고서 데이터를 불러오지 못했습니다.");
      })
      .finally(() => setLoading(false));
  };

  // 검색 시 page 리셋 및 트리거
  const handleSearch = () => {
    setPage(1);
    setSearchTrigger((v) => v + 1);
  };

  useEffect(() => {
    if (projectId) fetchData();
  }, [projectId, page, pageSize, searchTrigger]);

  return (
    <div className=" p-6 ">
        <PageHeader>완료보고서 목록</PageHeader>

      <BoardToolbar
        right={
          <>
            <SearchBar
              q={q}
              onChangeQ={setQ}
              searchField={searchField}
              onChangeSearchField={setSearchField}
              dateFilter={dateFilter}
              onChangeDateFilter={setDateFilter}
              startDate={startDate}
              endDate={endDate}
              onDateChange={({ start, end }) => {
                setStartDate(start);
                setEndDate(end);
              }}
              onSearch={handleSearch}
              pageSize={pageSize}
              onChangePageSize={setPageSize}
            />
            <button
              className="btn-create"
              onClick={() => navigate(`new`)}
            >
              새 문서 등록
            </button>
          </>
        }
      />

      {/* 리스트 */}
      <BoardTable
        columns={columns}
        rows={rows}
        loading={loading}
        error={error}
        emptyText="완료보고서가 없습니다."
        onRowClick={(row) => navigate(`${row.dns}/view`)}
      />

      {/* 페이지네이션 */}
      <div className="mt-4">
        <BoardPagination
          page={page}
          pageSize={pageSize}
          total={total}
          onPageChange={setPage}
        />
      </div>
    </div>
  );
};

export default OrderComplete;